import httpMethod from 'services/update2025/httpMethod';
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import React, { useContext, useRef } from "react";
import { useTranslation } from "react-i18next";
import { PersonInfoContext } from "./PersonInfoContext";
export const PersonInfoEditor = () => {
    const toast = useRef(null);
    const { t, i18n } = useTranslation(["person-info", "common"]);
    const tokenObj = httpMethod.getTokenStorage(); // { access_token, … }
    const accessToken = tokenObj?.access_token;;

    let headers = {
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": i18n.language,
    };

    const personInfoContext = useContext(PersonInfoContext);
    const { personInfoDetail, setPersonInfoDialog, personInfoDialog } = personInfoContext;

    const hideDialog = () => {
        setPersonInfoDialog(false);
    };
    return (
        <Dialog visible={personInfoDialog} style={{ width: "70%" }} header={t("person.title-detail")} modal className="p-fluid text-center" onHide={hideDialog}>
            <div className="formgrid">
                <div className="grid text-left">
                    <div className="col-12">
                        <div className="grid">
                            {/* Họ và tên */}
                            <div className="field col-12 md:col-4">
                                <label htmlFor="fullName2">{t("person.fullName2")}</label>
                                <InputText id="fullName2" value={personInfoDetail?.fullName} readOnly className="custom-form" />
                            </div>

                            {/* tên khác */}
                            <div className="field col-12 md:col-2">
                                <label htmlFor="otherName">{t("person.otherName")}</label>
                                <InputText id="otherName" value={personInfoDetail?.otherName} readOnly className="custom-form" />
                            </div>

                            <div className="field col-12 md:col-2">
                                <label htmlFor="gender">{t("person.gender")}</label>
                                <InputText id="gender" value={personInfoDetail?.gender} readOnly className="custom-form" />
                            </div>

                            <div className="field col-12 md:col-2">
                                <label htmlFor="birthDate">{t("person.birthDate")}</label>
                                <InputText id="birthDate" value={personInfoDetail?.birthDate} readOnly className="custom-form" />
                            </div>

                            <div className="field col-12 md:col-2">
                                <label htmlFor="accLevel">{t("person.accLevel")}</label>
                                <InputText id="accLevel" value={personInfoDetail?.accLevel} readOnly className="custom-form" />
                            </div>
                        </div>

                        <div className="grid">
                            <div className="field col-12 md:col-3">
                                <label htmlFor="idNumber">{t("person.idNumber")}</label>
                                <InputText id="idNumber" value={personInfoDetail?.idNumber} readOnly className="custom-form" />
                            </div>

                            <div className="field col-12 md:col-2">
                                <label htmlFor="idNumberOld">{t("person.idNumberOld")}</label>
                                <InputText id="idNumberOld" value={personInfoDetail?.idNumberOld} readOnly className="custom-form" />
                            </div>

                            <div className="field col-12 md:col-2">
                                <label htmlFor="phoneNumber">{t("person.phoneNumber")}</label>
                                <InputText id="phoneNumber" value={personInfoDetail?.phoneNumber} readOnly className="custom-form" />
                            </div>

                            <div className="field col-12 md:col-3">
                                <label htmlFor="email">{t("person.email")}</label>
                                <InputText id="email" value={personInfoDetail?.email} readOnly className="custom-form" />
                            </div>

                            <div className="field col-12 md:col-2">
                                <label htmlFor="maritalStatus">{t("person.maritalStatus")}</label>
                                <InputText id="maritalStatus" value={personInfoDetail?.maritalStatus} readOnly className="custom-form" />
                            </div>
                        </div>

                        <div className="grid">
                            <div
                                className="field col-4"
                                style={{
                                    display: "flex",
                                    margin: "auto",
                                }}
                            >
                                <Checkbox checked={personInfoDetail.homeTownForeign === "Y"} readOnly />
                                <label htmlFor="homeTownForeign">{t("person.homeTownForeign")}</label>
                            </div>

                            <div className="field col-4">
                                <label htmlFor="homeTown">{t("person.homeTown")}</label>
                                <InputText id="homeTown" type="text" value={personInfoDetail?.homeTown} readOnly className="custom-form" tooltip={personInfoDetail?.homeTown} tooltipOptions={{ position: "top" }} />
                            </div>

                            <div className="field col-4">
                                <label htmlFor="address">{t("person.address")}</label>
                                <InputText id="address" type="text" value={personInfoDetail?.address} readOnly className="custom-form" tooltip={personInfoDetail?.address} tooltipOptions={{ position: "top" }} />
                            </div>
                        </div>

                        <div className="grid">
                            <div className="field col-4">
                                <label htmlFor="birthPlace">{t("person.birthPlace")}</label>
                                <InputText id="birthPlace" type="text" value={personInfoDetail?.birthPlace} readOnly className="custom-form" tooltip={personInfoDetail?.birthPlace} tooltipOptions={{ position: "top" }} />
                            </div>

                            <div className="field col-4">
                                <label htmlFor="temporaryAddress">{t("person.temporaryAddress")}</label>
                                <InputText id="temporaryAddress" type="text" value={personInfoDetail?.temporaryAddress} readOnly className="custom-form" tooltip={personInfoDetail?.temporaryAddress} tooltipOptions={{ position: "top" }} />
                            </div>

                            <div className="field col-4">
                                <label htmlFor="curAddress">{t("person.curAddress")}</label>
                                <InputText id="curAddress" type="text" value={personInfoDetail?.curAddress} readOnly className="custom-form" tooltip={personInfoDetail?.curAddress} tooltipOptions={{ position: "top" }} />
                            </div>
                        </div>

                        <div className="grid">
                            <div className="field col-4">
                                <label htmlFor="nationality">{t("person.nationality")}</label>
                                <InputText id="nationality" type="text" value={personInfoDetail?.nationality} readOnly className="custom-form" />
                            </div>

                            {/* nhóm máu */}
                            <div className="field col-2">
                                <label htmlFor="bloodGroup">{t("person.bloodGroup")}</label>
                                <InputText id="bloodGroup" type="text" value={personInfoDetail?.bloodGroup} readOnly className="custom-form" />
                            </div>

                            <div className="field col-2">
                                <label htmlFor="ethnic">{t("person.ethnic")}</label>
                                <InputText id="ethnic" type="text" value={personInfoDetail?.ethnic} readOnly className="custom-form" />
                            </div>

                            <div className="field col-2">
                                <label htmlFor="religion">{t("person.religion")}</label>
                                <InputText id="religion" type="text" value={personInfoDetail?.religion} readOnly className="custom-form" />
                            </div>

                            <div className="field col-2">
                                <label htmlFor="deadDate">{t("person.deadDate")}</label>
                                <InputText id="deadDate" type="text" value={personInfoDetail?.deadDate} readOnly className="custom-form" />
                            </div>
                        </div>

                        <div className="grid">
                            <div className="field col-4">
                                <label htmlFor="fatherName">{t("person.fatherName")}</label>
                                <InputText id="fatherName" type="text" value={personInfoDetail?.fatherName} readOnly className="custom-form" />
                            </div>

                            <div className="field col-4">
                                <label htmlFor="motherName">{t("person.motherName")}</label>
                                <InputText id="motherName" type="text" value={personInfoDetail?.motherName} readOnly className="custom-form" />
                            </div>

                            <div className="field col-4">
                                <label htmlFor="mateName">{t("person.mateName")}</label>
                                <InputText id="mateName" type="text" value={personInfoDetail?.mateName} readOnly className="custom-form" />
                            </div>
                        </div>

                        <div className="grid">
                            <div className="field col-4">
                                <label htmlFor="fatherIdNumber">{t("person.fatherIdNumber")}</label>
                                <InputText id="fatherIdNumber" type="text" value={personInfoDetail?.fatherIdNumber} readOnly className="custom-form" />
                            </div>

                            <div className="field col-4">
                                <label htmlFor="motherIdNumber">{t("person.motherIdNumber")}</label>
                                <InputText id="motherIdNumber" type="text" value={personInfoDetail?.motherIdNumber} readOnly className="custom-form" />
                            </div>

                            <div className="field col-4">
                                <label htmlFor="mateIdNumber">{t("person.mateIdNumber")}</label>
                                <InputText id="mateIdNumber" type="text" value={personInfoDetail?.mateIdNumber} readOnly className="custom-form" />
                            </div>
                        </div>

                        <div className="grid">
                            <div className="field col-4">
                                <label htmlFor="fatherNationality">{t("person.fatherNationality")}</label>
                                <InputText id="fatherNationality" type="text" value={personInfoDetail?.fatherNationality} readOnly className="custom-form" />
                            </div>

                            <div className="field col-4">
                                <label htmlFor="motherNationality">{t("person.motherNationality")}</label>
                                <InputText id="motherNationality" type="text" value={personInfoDetail?.motherNationality} readOnly className="custom-form" />
                            </div>

                            <div className="field col-4">
                                <label htmlFor="materNationality">{t("person.materNationality")}</label>
                                <InputText id="materNationality" type="text" value={personInfoDetail?.materNationality} readOnly className="custom-form" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="grid">
                    <div className="col-12">
                        {/* close */}
                        <Button
                            style={{
                                width: "max-content",
                            }}
                            className="mr-2 p-button-danger"
                            label={t("close", { ns: "common" })}
                            icon="pi pi-times"
                            onClick={hideDialog}
                        />
                    </div>
                </div>
            </div>
        </Dialog>
    );
};
